<template>
    <div class="header">
        <div class="container">
            <div class="header-left">
                <div class="logo" @click="handleLogoClick">
                    <img src="@/assets/static/images/资源 17.png" alt="Logo">
                </div>
                
                <nav class="nav">
                    <a href="https://www.logogou.com/logo/creatlogo.html" target="_blank" class="nav-link">
                        智能logo设计
                        <span class="nav-badge">无需等待,点击前往</span>
                    </a>
                </nav>
            </div>
            <div class="auth-buttons">
                <template v-if="!isLoggedIn">
                    <button class="login-btn" @click="handleLoginClick">登录/注册</button>
                </template>
                <template v-else>
                    <div class="action-buttons">

                        <div class="recharge-btn-wrapper">
                            <button class="recharge-btn" @click="handleRechargeClick">
                                <span class="btn-text">充值豆豆</span>
                                <span class="beans-count">{{ userInfo.points_balance || 0 }}</span>
                            </button>
                            <img src="@/assets/static/images/蒙版组 175.png" alt="充值图标" class="recharge-icon-img">
                        </div>
                        <div class="vip-btn-wrapper">
                            <button class="vip-btn" @click="handleVipClick">
                                <div class="vip-text-group">
                                    <span v-if="!isVip" class="vip-text">开通vip会员 解锁更多特权</span>
                                    <span v-else class="vip-text">已开通vip会员</span>
                                    <span v-if="!isVip" class="vip-subtitle">VIP 会员专享「加速通道 + 隐藏福利」</span>
                                    <span v-else class="vip-subtitle">{{ formatVipExpireTime(userInfo.vip_expire_time) }}</span>
                                </div>
                            </button>
                            <img src="@/assets/static/images/蒙版组 174.png" alt="VIP图标" class="vip-icon-img">
                        </div>
                        <button class="history-btn" @click="handleHistoryClick">
                            <img src="@/assets/static/images/路径 592@2x.png" alt="历史记录图标" class="history-icon-img">
                            历史记录
                        </button>
                    </div>
                    <div class="user-info" @click="handleAvatarClick">
                        <div class="user-avatar">
                            <img :src="userInfo.avatar || defaultAvatar" alt="用户头像">
                            <div class="user-status"></div>
                        </div>
                        <div class="user-detail">
                            <div class="user-name">{{ userInfo.nick_name || userInfo.phone || '用户' }}</div>

                        </div>
                        <ArrowDown :class="{ 'is-active': showDropdown }" />

                        <div class="user-dropdown" v-show="showDropdown">
                            <div class="dropdown-header">
                                <div class="dropdown-avatar">
                                    <img :src="userInfo.avatar || defaultAvatar" alt="用户头像">
                                </div>
                                <div class="dropdown-info">
                                    <div class="dropdown-name">{{ userInfo.nick_name || userInfo.phone || '用户' }}</div>
                                    <div class="dropdown-level">{{ userInfo.level || '普通用户' }}</div>
                                </div>
                            </div>
                            <div class="dropdown-divider"></div>
                            <div class="dropdown-menu">
                                <div class="dropdown-item" @click="handleProfile">
                                    <User />
                                    <span>个人资料</span>
                                </div>
                                <div class="dropdown-item" @click="handleOrders">
                                    <Document />
                                    <span>我的订单</span>
                                </div>
                                <div class="dropdown-item" @click="handleFavorites">
                                    <Star />
                                    <span>我的收藏</span>
                                </div>
                                <div class="dropdown-item" @click="handleSettings">
                                    <Setting />
                                    <span>账号设置</span>
                                </div>
                            </div>
                            <div class="dropdown-divider"></div>
                            <div class="dropdown-menu">
                                <div class="dropdown-item logout" @click="handleLogout">
                                    <SwitchButton />
                                    <span>退出登录</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>

    <!-- 充值豆豆弹窗 -->
    <RechargeModal 
        v-model="showRechargeModal" 
        :user-info="userInfo"
        @confirm="handleRechargeConfirm"
    />

    <!-- 开通VIP弹窗 -->
    <VipModal 
        v-model="showVipModal" 
        :user-info="userInfo"
        @confirm="handleVipConfirm"
        @updateUserInfo="handleUpdateUserInfo"
    />
</template>

<script>
import { defineComponent, ref, computed, onMounted, onUnmounted, defineExpose } from 'vue'
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'
import { ArrowDown, User, Document, Star, Setting, SwitchButton } from '@element-plus/icons-vue'
import { isLoginApi, GetMyselfInfoApi } from '@/api/index'
import RechargeModal from './RechargeModal.vue'
import VipModal from './VipModal.vue'

export default defineComponent({
    name: 'HeaderNav',
    components: {
        RechargeModal,
        VipModal,
        ArrowDown,
        User,
        Document,
        Star,
        Setting,
        SwitchButton
    },
    emits: ['login-click', 'nav-click', 'logout', 'profile', 'orders', 'favorites', 'settings', 'recharge', 'vip', 'history'],
    setup(props, { emit }) {
        const router = useRouter()
        const isLoggedIn = ref(false)
        const showDropdown = ref(false)
        const showRechargeModal = ref(false)
        const showVipModal = ref(false)
        const userInfo = ref({})
        const defaultAvatar = require('@/assets/static/images/avatar.png')

        // 判断用户是否是VIP
        const isVip = computed(() => {
            return userInfo.value.level && userInfo.value.level.includes('VIP')
        })

        // 格式化VIP到期时间
        const formatVipExpireTime = (expireTime) => {
            if (!expireTime) return ''
            
            try {
                const date = new Date(expireTime)
                const now = new Date()
                const diffTime = date.getTime() - now.getTime()
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
                
                if (diffDays <= 0) {
                    return '已过期'
                } else if (diffDays <= 7) {
                    return `${diffDays}天后到期`
                } else {
                    return date.toLocaleDateString('zh-CN', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit'
                    })
                }
            } catch (error) {
                console.error('格式化VIP到期时间失败:', error)
                return ''
            }
        }

        const navItems = ref([
            { text: '首页', href: 'https://www.logogou.com/', active: true },
            { text: 'LOGO设计', href: 'https://www.logogou.com/logo/creatlogo.html', active: false },
            { text: '商标注册', href: '#', active: false },
            { text: '关于我们', href: 'https://www.logogou.com/abouts.html', active: false }
        ])

const checkLoginStatus = async (retryCount = 0) => {
    try {
        console.log(`🔍 HeaderNav checkLoginStatus 被调用，重试次数: ${retryCount}`)
        const res = await isLoginApi()
        console.log('📡 isLoginApi 响应:', res)
        isLoggedIn.value = res.data.success
        console.log('✅ 登录状态检查结果:', isLoggedIn.value);
        
        if (isLoggedIn.value) {
            console.log('🔄 开始获取用户信息...')
            await getUserInfo()
            console.log('👤 用户信息获取完成:', userInfo.value)
        } else if (retryCount < 1) {
            // 如果登录状态为false，等待200ms后重试（最多重试1次）
            console.log(`⏰ 登录状态检查失败，200ms后重试...`)
            setTimeout(() => {
                checkLoginStatus(retryCount + 1)
            }, 200)
        }
        return isLoggedIn.value
    } catch (error) {
        console.error('❌ 检查登录状态失败:', error)
        isLoggedIn.value = false
        return false
    }
}

        const getUserInfo = async () => {
            try {
                const res = await GetMyselfInfoApi()
                console.log(res.data.success);
                
                if (res.data.success) {
                    userInfo.value = res.data.data[0] || {}
                }
            } catch (error) {
                console.error('获取用户信息失败:', error)
            }
        }

        const handleNavClick = (item) => {
            navItems.value.forEach(nav => nav.active = nav === item)
            emit('nav-click', item)
        }

        const handleLoginClick = () => {
            emit('login-click')
        }

        const handleLogoClick = () => {
            window.open('https://www.logogou.com/', '_blank')
        }

        const handleAvatarClick = (event) => {
            showDropdown.value = !showDropdown.value
        }

        const handleLogout = () => {
            // 清除 localStorage
            localStorage.removeItem('userInfo')
            localStorage.removeItem('token')
            localStorage.removeItem('goods_id')
            
            // 清除 sessionStorage
            sessionStorage.removeItem('userInfo')
            sessionStorage.removeItem('token')
            sessionStorage.removeItem('goods_id')
            sessionStorage.removeItem('editLogoData')
            
            // 清除所有相关的 cookies
            const clearCookie = (name) => {
                // 清除不同路径和域名下的cookie
                const paths = ['/', '/ai-generator', '/canvas-editor']
                const domains = [
                    window.location.hostname,
                    `.${window.location.hostname}`,
                    window.location.hostname.split('.').slice(-2).join('.'),
                    `.${window.location.hostname.split('.').slice(-2).join('.')}`
                ]
                
                // 清除不同路径下的cookie
                paths.forEach(path => {
                    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path};`
                    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; domain=${window.location.hostname};`
                    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; domain=.${window.location.hostname};`
                })
                
                // 清除不同域名下的cookie
                domains.forEach(domain => {
                    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain};`
                })
                
                console.log(`已清除cookie: ${name}`)
            }
            
            // 清除常见的认证相关 cookies
            const cookiesToClear = [
                'token',
                'access_token',
                'auth_token',
                'session_id',
                'user_id',
                'userInfo',
                'login_token',
                'jwt',
                'authorization',
                'sessionid',
                'PHPSESSID',
                'JSESSIONID',
                'uuid',        // 用户唯一标识
                'sid',         // 会话ID
                'sessionId',   // 会话ID变体
                'user_uuid',   // 用户UUID变体
                'user_sid',    // 用户会话ID变体
                'auth_uuid',   // 认证UUID
                'auth_sid'     // 认证会话ID
            ]
            
            cookiesToClear.forEach(cookieName => {
                clearCookie(cookieName)
            })
            
            // 更新组件状态
            isLoggedIn.value = false
            userInfo.value = {}
            showDropdown.value = false
            
            // 触发父组件的登出事件
            emit('logout')
            
            console.log('✅ 已清除所有认证信息（localStorage、sessionStorage、cookies）')
            ElMessage.success('退出登录成功')
            
            // 强制刷新页面确保完全退出
            setTimeout(() => {
                window.location.reload()
            }, 1000)
        }

        const handleProfile = () => {
            showDropdown.value = false
            emit('profile')
        }

        const handleOrders = () => {
            showDropdown.value = false
            emit('orders')
        }

        const handleFavorites = () => {
            showDropdown.value = false
            emit('favorites')
        }

        const handleSettings = () => {
            showDropdown.value = false
            emit('settings')
        }

        // 历史记录相关方法
        const handleHistoryClick = () => {
            emit('history')
        }

        // 充值豆豆相关方法
        const handleRechargeClick = () => {
            showRechargeModal.value = true
        }

        const handleRechargeConfirm = (data) => {
            emit('recharge', data)
        }

        // VIP相关方法
        const handleVipClick = () => {
            showVipModal.value = true
        }

        const handleVipConfirm = (data) => {
            emit('vip', data)
        }

        // 处理VIP弹窗更新用户信息
        const handleUpdateUserInfo = async () => {
            await getUserInfo()
        }

        const handleClickOutside = (event) => {
            const userInfo = document.querySelector('.user-info')
            if (userInfo && !userInfo.contains(event.target)) {
                showDropdown.value = false
            }
        }

        onMounted(() => {
            checkLoginStatus()
            document.addEventListener('click', handleClickOutside)
        })

        onUnmounted(() => {
            document.removeEventListener('click', handleClickOutside)
        })

        // 暴露方法给父组件
        defineExpose({
            checkLoginStatus,
            getUserInfo,
            isLoggedIn,
            userInfo
        })

        return {
            navItems,
            isLoggedIn,
            showDropdown,
            showRechargeModal,
            showVipModal,
            userInfo,
            defaultAvatar,
            isVip,
            formatVipExpireTime,
            handleNavClick,
            handleLoginClick,
            handleLogoClick,
            handleAvatarClick,
            handleLogout,
            handleProfile,
            handleOrders,
            handleFavorites,
            handleSettings,
            handleHistoryClick,
            handleRechargeClick,
            handleRechargeConfirm,
            handleVipClick,
            handleVipConfirm,
            handleUpdateUserInfo,
            checkLoginStatus,
            getUserInfo
        }
    }
})
</script>

<style scoped>
.header {
    width: 100%;
    height: 60px;
    background: #fff;

   
    top: 0;
    left: 0;
    z-index: 100;
   
}

.container {
    max-width: 2100px;
    margin: 0 auto;
    padding: 0 20px;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 20px;
}

.logo {
    height: 35px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.logo:hover {
    transform: scale(1.05);
}

.logo img {
    height: 100%;
    width: auto;
    
}

.nav {
    display: flex;
    gap: 32px;
}

.nav-link {
    color: #ffffff;
    text-decoration: none;
    font-size: 14px;
    /* font-weight: 500; */
    padding: 8px 16px;
    position: relative;
    transition: all 0.3s;
    border-radius: 6px;
    background: #101010;
}

.nav-link:hover {
    color: #0066ff;
    background: rgba(0, 102, 255, 0.05);
    transform: translateY(-1px);
}

.nav-link:active {
    color: #0066ff;
    background: rgba(0, 102, 255, 0.1);
}

.nav-badge {
    background: linear-gradient(135deg, #ff6b35 0%, #f7931e 100%);
    color: white;
    font-size: 8px;

    padding: 2px 6px;
    border-radius: 3px;
    white-space: nowrap;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    position: absolute;
    top: -5px;
    left: 50%;
    transform: translateX(-50%);
    overflow: hidden;
    z-index: 10;
}

.nav-badge::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    animation: shine 3s infinite;
}

@keyframes shine {
    0% {
        left: -100%;
    }
    50% {
        left: 100%;
    }
    100% {
        left: 100%;
    }
}

.auth-buttons {
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.action-buttons {
    display: flex;
    gap: 8px;
   
}

.login-btn {
    padding: 8px 24px;
    background: linear-gradient(90deg, #0066ff 0%, #338bff 100%);
    color: #fff;
    border: none;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s;
}

.login-btn:hover {
    background: linear-gradient(90deg, #338bff 0%, #0066ff 100%);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 102, 255, 0.2);
}

.history-btn,
.recharge-btn,
.vip-btn {
    padding: 6px 12px;
    border: 1px solid #e6e6e6;
    border-radius: 20px;
    background: #E6E6E6;
    color: #666;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.3s;
    display: flex;
    align-items: center;
    gap: 4px;
    position: relative;
}

.history-btn{
    margin-left: 10px;
    border-radius: 8px;
    align-items: normal;
}
.vip-btn-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    margin-left: 10px;
}

.recharge-btn-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.vip-btn {
    background: linear-gradient(111deg, #eae2dc 0%, #edbf8b 58%, #e7a34f 100%);
    color: #4E3825;
    border: none;
    border-radius: 23px;
    padding: 5px 0px 2px 30px;
    height: 33px;
    width: 200px;
    max-width: 250px;
    border: 1px solid #FFE6C6;
    overflow: visible;
    flex-direction: row;
    align-items: center;
    gap: 6px;
    min-width: 110px;
    font-size: 14px;
    position: relative;
}

.vip-icon-img {
    position: absolute;
    left: -8px;
    top: 50%;
    transform: translateY(-50%);
    width: 30px;
    height: 30px;
    z-index: 2;
    pointer-events: none;
}

.recharge-btn {
    padding: 6px 12px 6px 20px;
    overflow: visible;
    position: relative;
}

.recharge-icon-img {
    position: absolute;
    left: -5px;
    top: 50%;
    transform: translateY(-50%);
    width: 25px;
    height: 25px;
    z-index: 2;
    pointer-events: none;
}

.recharge-btn .btn-text {
    margin-right: 4px;
    color: #94800c;
}

.beans-count {
    background:linear-gradient(135deg, #d3d734 0%, #94800c 100%);
    color: white;
    font-size: 11px;

    padding: 2px 6px;
    border-radius: 8px;
    margin-left: 0px;
    min-width: 20px;
    text-align: center;

}

.recharge-btn:hover {
    border-color: #52c41a;
    color: #52c41a;
    background: rgba(82, 196, 26, 0.05);
    transform: translateY(-1px);
}

.recharge-btn:hover .recharge-icon-img {
    transform: translateY(-50%) translateY(-1px);
}

.history-btn:hover {
    border-color: #8b5cf6;
    color: #8b5cf6;
    background: rgba(139, 92, 246, 0.05);
}

.recharge-btn:hover .beans-count {
    background: linear-gradient(135deg, #389e0d 0%, #52c41a 100%);
    box-shadow: 0 2px 6px rgba(82, 196, 26, 0.4);
    transform: scale(1.05);
}

.vip-btn:hover {
    background: linear-gradient(135deg, #fbba3f 0%, #d3b726 100%);
    box-shadow: 0 4px 12px rgba(217, 143, 52, 0.4);
    transform: translateY(-1px);
}

.vip-btn:hover .vip-icon-img {
    transform: translateY(-50%) translateY(-1px);
}

.history-icon-img {
    width: 14px;
    height: 18px;
    margin-right: 6px;
    vertical-align: middle;
}





.vip-btn .vip-text-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1px;
    line-height: 1;
}

.vip-btn .vip-text {
    font-size: 12px;
    line-height: 1;
}

.vip-btn .vip-subtitle {
    font-size: 8px;
    opacity: 0.9;
    line-height: 1;
    color: #9d8464;
    margin-top: 5px;
}

.user-info {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 4px 8px;
    border-radius: 24px;
    cursor: pointer;
    transition: all 0.3s;
    position: relative;
    flex-shrink: 0;
    min-width: 120px;

}

.user-info:hover {
    background: rgba(0, 102, 255, 0.05);
}

.user-info:active {
    background: rgba(0, 102, 255, 0.1);
}


.user-avatar {
    position: relative;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    overflow: hidden;

    flex-shrink: 0;

}

.user-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
}

.user-status {
    position: absolute;
    bottom: 2px;
    right: 2px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #52c41a;
    border: 2px solid #fff;
}

.user-detail {
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
}

.user-name {
    font-size: 14px;
    font-weight: 500;
    color: #333;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.user-level {
    font-size: 12px;
    color: #0066ff;
}

/* 箭头图标样式 - 更新为SVG */
.user-info > svg {
    width: 12px;
    height: 12px;
    color: #999;
    transition: transform 0.3s;
    flex-shrink: 0;
}

.user-info > svg.is-active {
    transform: rotate(180deg);
}

/* 下拉菜单图标大小控制 */
.dropdown-item svg {
    width: 16px;
    height: 16px;
}

.user-dropdown {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    width: 240px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    animation: dropdownFadeIn 0.2s ease;
}

.dropdown-header {
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 12px;
}

.dropdown-avatar {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    overflow: hidden;
    border: 2px solid #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.dropdown-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
}

.dropdown-info {
    flex: 1;
    min-width: 0;
}

.dropdown-name {
    font-size: 16px;
    font-weight: 500;
    color: #333;
    margin-bottom: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.dropdown-level {
    font-size: 12px;
    color: #666;
}

.dropdown-divider {
    height: 1px;
    background: #f0f0f0;
    margin: 4px 0;
}

.dropdown-menu {
    padding: 4px 0;
}

.dropdown-item {
    padding: 12px 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    color: #333;
    font-size: 14px;
    transition: all 0.3s;
    cursor: pointer;
}

.dropdown-item:hover {
    background: #f5f7fa;
    color: #0066ff;
}

.dropdown-item i {
    font-size: 16px;
    color: #666;
}

.dropdown-item:hover i {
    color: #0066ff;
}

.dropdown-item.logout {
    color: #ff4d4f;
}

.dropdown-item.logout:hover {
    background: #fff1f0;
}

.dropdown-item.logout i {
    color: #ff4d4f;
}

@keyframes dropdownFadeIn {
    from {
        opacity: 0;
        transform: translateY(-8px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (max-width: 768px) {
    .header {
        height: 60px;
    }

    .container {
        padding: 0 16px;
    }

    .header-left {
        gap: 20px;
    }

    .logo {
        height: 32px;
    }

    .nav {
        gap: 16px;
    }

    .nav a {
        font-size: 14px;
    }

    .login-btn {
        padding: 6px 16px;
        font-size: 13px;
    }

    .user-info {
        padding: 2px 6px;
    }

    .user-avatar {
        width: 32px;
        height: 32px;
    }

    .user-name {
        font-size: 13px;
        max-width: 80px;
    }

    .user-level {
        font-size: 11px;
    }

    .user-dropdown {
        width: 200px;
    }

    .dropdown-header {
        padding: 12px;
    }

    .dropdown-avatar {
        width: 40px;
        height: 40px;
    }

    .dropdown-name {
        font-size: 14px;
    }
}

@media (max-width: 600px) {
    .nav {
        display: none;
    }
    
    .nav-link {
        font-size: 14px;
        padding: 6px 12px;
    }
    
    .nav-badge {
        font-size: 7px;
        padding: 1px 4px;
        letter-spacing: 0.3px;
        top: -6px;
    }
    
    .action-buttons {
        margin-right: 8px;
    }
    
    .history-btn,
    .recharge-btn,
    .vip-btn {
        padding: 6px 8px;
        min-width: 90px;
        gap: 4px;
    }
    
    .history-icon-img {
        width: 14px;
        height: 16px;
        margin-right: 4px;
    }
    
    .vip-btn {
        padding: 6px 8px 6px 16px;
        min-width: 85px;
        width: auto;
        max-width: 150px;
    }
    
    .vip-icon-img {
        width: 24px;
        height: 24px;
        left: -6px;
    }
    
    .vip-btn .vip-text {
        font-size: 11px;
    }
    
    .vip-btn .vip-subtitle {
        font-size: 9px;
    }
    
    .recharge-btn {
        padding: 6px 8px 6px 16px;
    }
    
    .recharge-icon-img {
        width: 24px;
        height: 24px;
        left: -6px;
    }
    
    .beans-count {
        font-size: 10px;
        padding: 1px 4px;
        min-width: 16px;
    }
}




</style>